!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Add body padding depending on the height of the page-header-small.
   */
  Drupal.behaviors.pageHeaderSmall = {
    attach: context => {
      /**
       * Push body element down with whitespace.
       * Ensures sticky header does not overlap hero image content.
       * @returns {void}
       */
      function pageHeaderSmallPadBody() {
        // Relying on window.width() is unreliable due browser scrollbar sizes.
        const breakPointLg = window.matchMedia('(min-width: 992px)');

        if (!breakPointLg.matches) {
          const $pageHeaderSmallHeights = $('.js-page-header-small');
          $('body').css('paddingTop', $pageHeaderSmallHeights.outerHeight());
        }
        else {
          $('body').css('paddingTop', 0);
        }
      }

      $(once('pageHeaderSmallPadBody', 'body', context))
        .each(function() {
          pageHeaderSmallPadBody();
          // Always set setHeight on resize
          // setTimeout was removed to prevent flash of white space above
          // header on resize.
          $(window).resize(function() {
            pageHeaderSmallPadBody();
          });
        });
    },
  };

})(document, Drupal, jQuery, once);
